import React, {useState, useCallback} from 'react'
import ButtonUseCB from '../../Exos/12-useCallback/button'
import CountUseCB from '../../Exos/12-useCallback/Count'
import Profil from '../../Exos/14-useMemo/profile'
const ExosFunction = () => {

    const [CountOne, setCountOne] = useState({value : 0, btnColor: 'success', increment: 25});
    const [CountTwo, setCountTwo] = useState({value : 0, btnColor: 'danger', increment: 20});


    const incrementCountOne = useCallback( (val) => {
        console.log('je suis dans incremontContOne');
        CountOne.value < 100 &&  setCountOne( {...CountOne, value: CountOne.value + val} )  // pour créer une copie de l'objet
    } , [CountOne]
)
    
   
    const incrementCountTwo = useCallback((val) => {
        console.log('je suis dans incremontContTwo');
        CountTwo.value < 100 &&  setCountTwo( {...CountTwo, value: CountTwo.value + val} )  // pour créer une copie de l'objet
    } , [CountTwo] )
    
    var MagicNumber = 2
    if (MagicNumber == 2) {
        return 
    }

    return (
        <div>

            <div className="container border text-center">
                <div className="row">
                    <div className="col-12 col-md-3 border border-danger bg-dark text-white p-5 rounded-lg shadow-lg m-2">1/3</div>
                    <div className="col-12 col-md-4 border border-success bg-secondary rounded-circle p-5">1/3</div>
                    <div className="col-12 col-md-4 border border-primary">1/3</div>
                </div>
                <button className="btn btn-danger">Click me</button>
            </div>

            



            <div className="container">
                <h1 className="text-center">useMemo()</h1>
                <button className="btn btn-info mb-3">Incrément</button>
                <button className="btn btn-dark Float-right">Modifier</button>
                <Profil />
            </div>

                
                <CountUseCB text='CountOne' Count={CountOne.value} bgColor={CountOne.btnColor} />
                <CountUseCB text='CountTwo' Count={CountTwo.value} bgColor={CountTwo.btnColor} />
                <ButtonUseCB handeClick={incrementCountOne} btnColor={CountOne.btnColor} increment={CountOne.increment}>Count 1</ButtonUseCB>
                <ButtonUseCB handeClick={incrementCountTwo} btnColor={CountTwo.btnColor} increment={CountTwo.increment}>Count 2</ButtonUseCB>

        </div>
    )
}

export default ExosFunction
